import type { ReverseCard } from '../types';

export const REVERSE_CARDS: ReverseCard[] = [
  {
    id: '乾坤一掷',
    name: '乾坤一掷',
    emoji: '🎲',
    type: 'reverse',
    description: '押注所有现金（保底200），猜骰子点数。猜中得2倍，猜错归零',
    effectCategory: 'economy',
    canTarget: false,
    cost: 500,
  },
  {
    id: '一夜暴富',
    name: '一夜暴富',
    emoji: '🎰',
    type: 'reverse',
    description: '掷特殊骰子：1-2得200、3-4得500、5-6得1000',
    effectCategory: 'economy',
    canTarget: false,
    cost: 400,
  },
  {
    id: '拆迁令',
    name: '拆迁令',
    emoji: '🏚',
    type: 'reverse',
    description: '指定一条街，所有建筑降一级，地主获市场价30%补偿',
    effectCategory: 'economy',
    canTarget: true,
    cost: 450,
  },
  {
    id: '时光倒流',
    name: '时光倒流',
    emoji: '🔄',
    type: 'reverse',
    description: '自己回到上一圈的位置（不影响他人）',
    effectCategory: 'rule',
    canTarget: false,
    cost: 350,
  },
  {
    id: '精准导航',
    name: '精准导航',
    emoji: '🎯',
    type: 'reverse',
    description: '下回合可自选骰子点数（1-6步）',
    effectCategory: 'rule',
    canTarget: false,
    cost: 300,
  },
  {
    id: '强制联盟',
    name: '强制联盟',
    emoji: '🤝',
    type: 'reverse',
    description: '与一名玩家强制结盟2回合（互相免收租金，不可提前解除）',
    effectCategory: 'social',
    canTarget: true,
    cost: 400,
  },
];
